import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropertyRecord from '../records/PropertyRecord';
import TaxonomyInputUtils from '../utils/TaxonomyInputUtils';
import { PRODUCT_INTEREST } from '../constants/ConversationsProperties';
import ThreadRecord from '../records/ThreadRecord';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const NOT_APPLICABLE = 'NOT_APPLICABLE';
const currentValuePropDefault = new PropertyRecord({
  name: PRODUCT_INTEREST
});
const ProductInterestSelect = ({
  allProperties,
  currentValue = currentValuePropDefault,
  displayMode,
  isUpdatingProperty,
  onChange,
  ghosted = false,
  threadRecord
}) => {
  const handleNotApplicableOption = value => {
    if (value[value.length - 1] === NOT_APPLICABLE) {
      return [NOT_APPLICABLE];
    }
    return value.filter(option => option !== NOT_APPLICABLE);
  };
  const shouldDisableInput = () => ghosted || !threadRecord.requiresProductAndTier();
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.taxonomy.property.product.label"
    }),
    displayOptimized: displayMode === 'card',
    children: /*#__PURE__*/_jsx(Select, {
      anchorType: "button",
      buttonUse: displayMode === 'panel' ? 'form' : undefined,
      paddingInlineStart: displayMode === 'card' ? '0' : undefined,
      "data-test-id": "product-interest-select-input",
      menuWidth: displayMode === 'panel' ? 350 : 250,
      multiCollapseLimit: 3,
      multi: true,
      onChange: ({
        target: {
          value
        }
      }) => {
        const adjustedValue = handleNotApplicableOption(value);
        onChange(new PropertyRecord({
          name: PRODUCT_INTEREST,
          value: adjustedValue,
          revisionCode: currentValue ? currentValue.revisionCode : 0
        }));
      },
      options: TaxonomyInputUtils.mapPropertiesToOptions({
        properties: allProperties,
        propertyKey: 'product',
        disabled: isUpdatingProperty,
        priorityValues: ['CRM_SUITE']
      }),
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.taxonomy.property.product.placeholder"
      }),
      readOnly: shouldDisableInput(),
      value: currentValue.value || null
    })
  });
};
ProductInterestSelect.propTypes = {
  allProperties: ImmutablePropTypes.list.isRequired,
  currentValue: PropTypes.instanceOf(PropertyRecord),
  displayMode: PropTypes.string.isRequired,
  ghosted: PropTypes.bool,
  isUpdatingProperty: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  threadRecord: PropTypes.instanceOf(ThreadRecord).isRequired
};
export default ProductInterestSelect;